import { gql } from '@apollo/client'

export default gql`
    mutation DownloadCaption ($taskId: ID!, $type: String) {
        downloadCaption(taskId: $taskId, type: $type)
    }
`